import { useSessionMonitor } from '../../hooks/useSessionMonitor';

/**
 * Component that monitors session state and handles automatic logout
 * This component should be placed inside the Router context
 */
function SessionMonitor() {
  // Monitor session state and handle automatic logout
  useSessionMonitor();
  
  // This component doesn't render anything, it just monitors session state
  return null;
}

export default SessionMonitor;
